import { SelectOption } from "./multi-select"
import './single-select.less'

interface Iprops {
    width?: number
    options?: SelectOption[]
    selectedKey: string
    handleSelectItem: (key: string, label: string) => void
}

export default function SingleSelect(props: Iprops) {
    return (
        <div className="tn-single-select-wrap" >
            {(props.options || []).map((item, index) => (
                <div key={index} className="option" onClick={(e) => {
                    props.handleSelectItem(item.key, item.label)
                }}>
                    <div className="label ellipsis">{item?.label}</div>
                </div>
            ))}
            {(props.options || []).length == 0 && (
                <div>无数据</div>
            )}
        </div>
    )
}